import React from "react";
import PropTypes from "prop-types"
import _ from "lodash";
import ReactHtmlParser from 'react-html-parser';


import {
    Row,
    Col,
} from "reactstrap";

const FormErrorWidget = ({errors,displayFirstColumnAsSpace})=>{
    return(
        <Row>
            <Col xs="12">
                <div className="alert alert-danger" role="alert">
                    <Row>
                        {
                            displayFirstColumnAsSpace &&
                            <Col xs="1" sm="1" className="">
                            </Col>
                        }
                        <Col>
                        <ul>
                            <span className="font-weight-bold">Following error occured:</span>
                            {
                                _.values(errors).map((e,i)=>{
                                    return(
                                        <li key={i}>
                                            {ReactHtmlParser(e)}
                                        </li> 
                                    );
                                })

                            }
                            
                        </ul> 
                        </Col>
                        
                        
                    </Row>
                    
                </div>
            </Col>
        </Row>
    );
}

FormErrorWidget.propTypes = {
    errors:PropTypes.object.isRequired,
    displayFirstColumnAsSpace:PropTypes.bool.isRequired,
}

FormErrorWidget.defaultProps = {
    displayFirstColumnAsSpace:true,
    
}

export default FormErrorWidget;